import type { CSSProperties, Dispatch, ReactNode, SetStateAction } from 'react';
import { CM_INSURANCE_TYPES } from '@lib/cmServices';
import type { ModalFormState } from '@app/modal-form-types';
import { formDeliverables, formField } from '@app/modal-form-types';
import CmDeliverablesEditor from './cm-deliverables-editor';
import CmPaymentSummary from './cm-payment-summary';

function Field({
  label,
  children,
  style,
}: {
  label: string;
  children: ReactNode;
  style?: CSSProperties;
}) {
  return (
    <div className="fg2" style={style}>
      <label>{label}</label>
      {children}
    </div>
  );
}

export default function CmServicesFormSection({
  form,
  set,
  setForm,
}: {
  form: ModalFormState;
  set: (key: string, val: unknown) => void;
  setForm: Dispatch<SetStateAction<ModalFormState>>;
}) {
  return (
    <>
      <div className="cm-form-sec-title" style={{ gridColumn: '1 / -1' }}>Core Data</div>
      <Field label="Firm / Consultant">
        <input type="text" value={formField(form, 'firm') || ''} onChange={(e) => set('firm', e.target.value)} />
      </Field>
      <Field label="Date of Contract Signing">
        <input type="date" value={formField(form, 'contract') || ''} onChange={(e) => set('contract', e.target.value)} />
      </Field>
      <Field label="Date of Commencement">
        <input type="date" value={formField(form, 'comm') || ''} onChange={(e) => set('comm', e.target.value)} />
      </Field>

      <CmPaymentSummary form={form} />

      <div className="cm-form-sec-title" style={{ gridColumn: '1 / -1' }}>Payment Amounts</div>
      <Field label="Total Remuneration (PKR)">
        <input type="number" min={0} value={formField(form, 'totalRemuneration')} onChange={(e) => set('totalRemuneration', e.target.value)} />
      </Field>
      <Field label="Total Reimbursable (PKR)">
        <input type="number" min={0} value={formField(form, 'totalReimbursable')} onChange={(e) => set('totalReimbursable', e.target.value)} />
      </Field>
      <Field label="Total Amount Paid (PKR)">
        <input type="number" min={0} value={formField(form, 'paidAmount')} onChange={(e) => set('paidAmount', e.target.value)} />
      </Field>
      <Field label="Amount Paid – Remuneration (PKR)">
        <input type="number" min={0} value={formField(form, 'paidRemuneration')} onChange={(e) => set('paidRemuneration', e.target.value)} />
      </Field>
      <Field label="Amount Paid – Reimbursable (PKR)">
        <input type="number" min={0} value={formField(form, 'paidReimbursable')} onChange={(e) => set('paidReimbursable', e.target.value)} />
      </Field>
      <Field label="Payment % (Manual)">
        <input type="number" min={0} max={100} value={formField(form, 'paymentPct')} onChange={(e) => set('paymentPct', e.target.value)} />
      </Field>
      <Field label="Payment % Remarks" style={{ gridColumn: '1 / -1' }}>
        <textarea
          value={formField(form, 'paymentPctRemarks') || ''}
          onChange={(e) => set('paymentPctRemarks', e.target.value)}
          rows={2}
          placeholder="Remarks for manual percentage calculation"
        />
      </Field>

      <div className="cm-form-sec-title" style={{ gridColumn: '1 / -1' }}>Insurance</div>
      <Field label="Insurance Status">
        <select value={formField(form, 'insurance') || 'Valid'} onChange={(e) => set('insurance', e.target.value)}>
          <option>Valid</option>
          <option>Expired</option>
        </select>
      </Field>
      <Field label="Insurance Type">
        <select value={formField(form, 'insuranceType') || ''} onChange={(e) => set('insuranceType', e.target.value)}>
          <option value="">— Select type —</option>
          {CM_INSURANCE_TYPES.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </Field>
      <Field label="Insurance Name">
        <input type="text" value={formField(form, 'insuranceName') || ''} onChange={(e) => set('insuranceName', e.target.value)} />
      </Field>
      <Field label="Date of Issuance">
        <input type="date" value={formField(form, 'insuranceIssuance') || ''} onChange={(e) => set('insuranceIssuance', e.target.value)} />
      </Field>
      <Field label="Date of Expiry">
        <input type="date" value={formField(form, 'insuranceExpiry') || ''} onChange={(e) => set('insuranceExpiry', e.target.value)} />
      </Field>
      <Field label="Insurance Remarks" style={{ gridColumn: '1 / -1' }}>
        <textarea value={formField(form, 'insuranceRemarks') || ''} onChange={(e) => set('insuranceRemarks', e.target.value)} rows={2} />
      </Field>

      <div style={{ gridColumn: '1 / -1' }}>
        <CmDeliverablesEditor
          deliverables={formDeliverables(form)}
          onChange={(deliverables) => setForm((prev) => ({ ...prev, deliverables }))}
        />
      </div>
    </>
  );
}
